import styled from 'styled-components';

export default (Component) => styled(Component)`
  .bulk-modal__summary {
    margin-bottom: 16px;
    font-size: 12px;
    color: #666;
  }
  .bulk-modal__field {
    margin-bottom: 16px;
    label {
      display: block;
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      margin-bottom: 6px;
      color: #01366b;
    }
    input,
    .react-datepicker-wrapper {
      width: 100%;
    }
  }
  .file {
    .btn__file {
      height: 40px;
      padding: 10px 20px;
      display: inline-block;
      text-align: center;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      transition-property: background-color;
      transition-duration: 0.5s;
      cursor: pointer;
      background-color: #ffffff;
      color: #00a6ff;
      border: 1px solid #00a6ff;
      border-radius: 30px;
    }
    margin-bottom: 15px;
    text-align: center;
    input {
      display: none;
    }
  }
  .oldFile {
    text-align: center;
    word-break: break-all;
    span {
      color: #01366b;
      padding-right: 10px;
    }
    i {
      color: #01366b;
    }
    margin-bottom: 15px;
  }
  .validate {
    a {
      height: 40px;
      padding: 10px 20px;
    }
    margin: 0px auto;
    text-align: center;
  }
  .bulk-modal__results {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #eee;
    p {
      margin-bottom: 8px;
    }
    .error {
      color: #d0021b;
    }
  }
  .page-profil__alert-bloc {
    width: 100%;
    margin-bottom: 20px;
    .alert-bloc__label {
      display: block;
      color: #d0021b;
      font-family: Montserrat;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.15px;
      line-height: 15px;
      text-align: center;
      &:before {
        content: '*';
      }
    }
  }
`;
